import React from 'react';
import { generatePath } from 'react-router';
import history from '@AppRoutes/history';
import { getTrackingPathName } from '@AppRoutes/AppRoutesSelectors';
import { paths } from '@AppRoutes/constants';
import PropTypes from 'prop-types';
import AppStorage from '@Services/AppStorage';
import Catalyst from '@Services/Catalyst';
import store from '@Store';
import DialogWithConfirmationLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithConfirmationLayout';

function AlertLoginDialog({ alert, selfClose, ...props }) {
  function _trackingPageMap() {
    let page;
    const route = getTrackingPathName(store.getState()) || '';

    // eslint-disable-next-line default-case
    switch (route) {
      case 'main.search.quick.results':
        page = 'preview';
        break;
      case 'main.results.context':
      case 'main.results.heatmap':
        page = 'resultspage';
        break;
      case 'main.history.recent':
      case 'main.history.saved':
        page = 'history';
        break;
    }
    return page;
  }

  const goToSignIn = () => {
    Catalyst.trackConversionDriverClick(`${_trackingPageMap()}:createalert:sign-in`);
    AppStorage.instance.set('scheduledAlert', alert);
    selfClose();
    history.push({
      pathname: generatePath(paths.LOGIN),
    });
  };

  const onCancel = () => {
    AppStorage.instance.set('scheduledAlert', null);
    selfClose();
  };

  return (
    <DialogWithConfirmationLayout {...props} closeBtn={false} header="Login required" selfClose={onCancel} onYesClick={goToSignIn}>
      Please sign-in/register to create an Alert.
    </DialogWithConfirmationLayout>
  );
}

AlertLoginDialog.propTypes = {
  selfClose: PropTypes.func,
  alert: PropTypes.object.isRequired,
};

export default AlertLoginDialog;
